import { render, staticRenderFns } from "./pingtai.vue?vue&type=template&id=1bb45afe&scoped=true&"
import script from "./pingtai.vue?vue&type=script&lang=js&"
export * from "./pingtai.vue?vue&type=script&lang=js&"
import style0 from "./pingtai.vue?vue&type=style&index=0&id=1bb45afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb45afe",
  null
  
)

export default component.exports